
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomumbaiinnovacabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Innova Crysta Cab  ',
        heading: 'Vedant Travels: Pune to Mumbai Innova Crysta Cab  ',
        headingDescription: 'Vedant Travels offers affordable and transparent taxi fares for Pune to Mumbai Innova Crysta cab services, ensuring a comfortable, luxurious, and smooth journey. The Innova Crysta is ideal for those looking for extra space, comfort, and premium amenities. Our pricing is competitive, with no hidden charges, and we provide multiple cab options to suit your needs.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


"services": [
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Experience a comfortable and luxurious journey from Pune to Mumbai with Vedant Travels. Our fleet includes the premium Innova, perfect for those who want a smooth and stylish ride. Whether you're traveling for business or leisure, we ensure your comfort throughout the trip."
    },
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Need a reliable ride to Mumbai International Airport? Vedant Travels offers Innova cabs for airport drops, ensuring you reach your destination on time and in comfort. Book your ride today for a hassle-free airport transfer."
    },
    {
        "name": "Pune Mumbai Innova Rental",
        "description": "For those seeking flexibility, rent an Innova with Vedant Travels. We offer a range of rental options, whether it’s a one-way trip or a round journey. Choose the Innova for a spacious and comfortable travel experience between Pune and Mumbai."
    },
    {
        "name": "Pune to Mumbai Airport Innova",
        "description": "Vedant Travels provides reliable and comfortable Innova cabs for your airport journey from Pune to Mumbai. Our drivers are experienced and ensure timely arrivals and departures, making your travel stress-free."
    },
    {
        "name": "Innova Crysta on Rent Pune",
        "description": "Rent a luxurious Innova Crysta for your journey with Vedant Travels. The Innova Crysta offers extra comfort, space, and style, perfect for those looking for a premium experience on their travel from Pune to Mumbai or any other destination."
    },
    {
        "name": "Pune to Mumbai One Way Innova Taxi",
        "description": "Looking for a one-way trip from Pune to Mumbai? Vedant Travels offers affordable one-way Innova taxis that ensure you travel comfortably, with the flexibility to choose your pick-up and drop-off locations."
    },
    {
        "name": "Pune to Mumbai Darshan Innova Taxi",
        "description": "For a religious or sightseeing trip, choose Vedant Travels' Innova taxis for a comfortable and smooth journey. Our experienced drivers will ensure your Darshan trip from Pune to Mumbai is convenient and timely."
    },
    {
        "name": "Pune to Dadar Innova Taxi Fare",
        "description": "For your ride from Pune to Dadar, Vedant Travels offers transparent and competitive pricing. We ensure your journey is comfortable, stress-free, and reasonably priced, whether you're traveling solo or with family."
    },
    {
        "name": "Pune to Andheri Innova Crysta",
        "description": "For a premium ride from Pune to Andheri, book an Innova Crysta with Vedant Travels. The Crysta is ideal for those who desire a luxurious and spacious vehicle for their travels."
    },
    {
        "name": "Pune to Mumbai Round Trip Innova Crysta",
        "description": "Planning a round trip from Pune to Mumbai? Rent the Innova Crysta with Vedant Travels for an exceptional travel experience. Our round trip service ensures flexibility and convenience throughout your journey."
    },
    {
        "name": "Pune to Mumbai Airport Innova Crysta Cab",
        "description": "Looking for the ultimate comfort for your airport drop? Vedant Travels offers Innova Crysta cabs for your Pune to Mumbai airport journey, combining luxury, space, and reliability."
    },
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Get a stress-free ride to Mumbai Airport with Vedant Travels’ Innova drop service. Whether you're catching an early flight or arriving late, our experienced drivers ensure your timely arrival."
    },
    {
        "name": "Innova Hire in Pune",
        "description": "If you need to hire an Innova in Pune, Vedant Travels offers flexible rental services with a fleet of well-maintained vehicles. Choose the Innova for a spacious and comfortable travel experience."
    },
    {
        "name": "8 Seater Innova on Rent Pune",
        "description": "Traveling in a group? Hire an 8-seater Innova from Vedant Travels. Our vehicles are spacious and equipped for a comfortable and safe journey."
    },
    {
        "name": "Innova Crysta on Rent Pune",
        "description": "Vedant Travels offers Innova Crysta rentals in Pune, perfect for those seeking a luxury travel experience. Whether it’s for a business trip, family outing, or airport transfer, the Innova Crysta ensures a comfortable ride."
    },
    {
        "name": "7 Seater Innova on Rent in Pune",
        "description": "For family or group trips, rent a 7-seater Innova with Vedant Travels. Our 7-seater options are perfect for larger groups traveling between Pune and Mumbai or to other destinations."
    },
    {
        "name": "Innova Per Km Rate for Outstation",
        "description": "Vedant Travels offers competitive per kilometer rates for outstation trips in the Innova. Whether you're planning a long-distance journey or just a quick getaway, we ensure affordability and comfort."
    },
    {
        "name": "Innova Crysta on Rent in Pimpri Chinchwad",
        "description": "Need an Innova Crysta for your journey from Pimpri Chinchwad? Vedant Travels offers convenient rental services in the area, giving you access to premium vehicles at competitive rates."
    },
    {
        "name": "Vedant Travels Pune",
        "description": "For reliable, comfortable, and affordable cab services in Pune, choose Vedant Travels. We specialize in providing a smooth travel experience, whether it’s a local ride or a long-distance trip."
    },
    {
        "name": "Cab Service in Pune",
        "description": "Vedant Travels offers high-quality, reliable cab services in Pune, ensuring a comfortable journey every time. Our fleet includes a variety of vehicles, including the Innova and Innova Crysta, suited for all your travel needs."
    },
    {
        "name": "Pune to Mumbai Airport Cab",
        "description": "Choose Vedant Travels for your Pune to Mumbai airport cab needs. Our punctual and professional service ensures you reach your flight on time and travel in comfort."
    },
    {
        "name": "Pune Mumbai Cab",
        "description": "Book your Pune to Mumbai cab with Vedant Travels for a smooth and comfortable ride. We offer a range of vehicles, from standard cabs to premium options like the Innova Crysta, to suit your travel requirements."
    },
    {
        "name": "Contact Information",
        "description": "For bookings or inquiries, contact Vedant Travels at +91 8208126878. We ensure a comfortable and stress-free ride, making your travel experience a pleasant one."
    }
],


"tableData": [
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Airport Drop Innova"],
    ["Pune Mumbai Innova Rental", "Pune to Mumbai Airport Innova"],
    ["Pune to Mumbai One Way Innova Taxi", "Pune to Mumbai Darshan Innova Taxi"],
    ["Pune to Dadar Innova Taxi Fare", "Pune to Andheri Innova Crysta"],
    ["Pune to Mumbai Round Trip Innova Crysta", "Pune to Mumbai Airport Innova Crysta Cab"],
    ["Pune to Mumbai Airport Drop Innova", "Innova Hire in Pune"],
    ["8 Seater Innova on Rent Pune", "Innova Crysta on Rent Pune"],
    ["7 Seater Innova on Rent in Pune", "Innova Per Km Rate for Outstation"],
    ["Innova Crysta on Rent in Pimpri Chinchwad", "Vedant Travels Pune"],
    ["Cab Service in Pune", "Pune to Mumbai Airport Cab"],
    ["Pune Mumbai Cab", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we know that time is precious. Whether you are traveling for a business meeting or a family trip, our drivers ensure that you are picked up on time and dropped off promptly at your destination. With our Innova Crysta cabs, you’ll enjoy a hassle-free journey from Pune to Mumbai."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "The Innova Crysta is the ideal vehicle for long-distance travel, offering ample space, comfortable seating, and a smooth ride. Equipped with air conditioning, plush interiors, and modern amenities, the Innova Crysta ensures that your journey from Pune to Mumbai is both comfortable and enjoyable."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are experienced and skilled in handling long-distance trips, ensuring that your travel experience is smooth, safe, and efficient. They are familiar with the best routes from Pune to Mumbai and are committed to providing you with the most comfortable and timely ride."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing for Pune to Mumbai Innova Crysta cabs. There are no hidden charges—our pricing model ensures you know exactly what you’re paying for, with no surprises."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. The Innova Crysta is equipped with advanced safety features, including airbags, seat belts, and GPS tracking. Our drivers strictly follow safety protocols to ensure a safe and worry-free journey from Pune to Mumbai."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it’s an early morning trip or a late-night return, Vedant Travels is available around the clock. You can book an Innova Crysta cab anytime, and our customer service team will ensure prompt assistance."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Pune to Mumbai Innova Crysta cab is quick and easy. You can book your cab online via our website or mobile app, or simply reach out to our customer service team for personalized assistance."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We understand that every trip is unique. Whether you're traveling for business, leisure, or a special event, we offer customized travel packages for your Pune to Mumbai journey. Just let us know your requirements, and we’ll tailor the experience to meet your needs."
    }
  ]





    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai Innova Crysta cab with Vedant Travels?',
            answer: 'You can easily book a cab online through our website or mobile app. Alternatively, you can contact our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Is the Innova Crysta suitable for long-distance travel?',
            answer: 'Yes, the Innova Crysta is perfect for long-distance travel. It offers a comfortable ride with spacious seating and ample legroom, making it ideal for the Pune to Mumbai journey.',
        },
        {
            id: 3,
            question: 'What is the seating capacity of the Innova Crysta?',
            answer: 'The Innova Crysta comfortably accommodates up to 7 passengers, making it an excellent choice for families or small groups traveling together.',
        },
        {
            id: 4,
            question: 'How do I pay for my Pune to Mumbai Innova Crysta cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payment via our app, ensuring flexibility and convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip Pune to Mumbai Innova Crysta cab?',
            answer: 'Yes, you can book a round-trip Innova Crysta cab. Simply provide the return details during your booking, and we will arrange everything.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront at the time of booking, ensuring full transparency in pricing.',
        },
        {
            id: 7,
            question: 'Can I hire an Innova Crysta for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, we offer sightseeing tours in Mumbai. After your Pune to Mumbai journey, you can explore popular landmarks like the Gateway of India, Marine Drive, and more with our experienced drivers.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pune to Mumbai Innova Crysta cab?',
            answer: 'The Innova Crysta provides ample luggage space, easily accommodating standard luggage. If you have extra luggage or special requirements, please inform us at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Pune and Mumbai?',
            answer: 'Yes, we provide corporate travel services for business meetings, conferences, and other professional events. We can tailor the journey to meet the specific needs of your company.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Pune to Mumbai Innova Crysta journey?',
            answer: 'Vedant Travels is known for its reliable service, professional drivers, well-maintained vehicles, and transparent pricing. Our Innova Crysta cabs offer a comfortable, safe, and enjoyable experience for your journey from Pune to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sandeep Verma",
            title: "Customer",
            quote: "We booked the Innova Crysta for our family trip from Pune to Mumbai, and it was a fantastic experience. The vehicle was spacious and clean, the driver was professional, and the ride was very comfortable. Highly recommend Vedant Travels!",
            rating: 5,
        },
        {
            name: "Ms. Anjali Joshi",
            title: "Customer",
            quote: "I used Vedant Travels for a corporate trip from Pune to Mumbai in an Innova Crysta. The vehicle was perfect for our group, and the driver was punctual and professional. The journey was smooth and hassle-free. Will definitely use them again.",
            rating: 5,
        },
    ];
    










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Crysta Cab",
  "image": "https://vedanttravels.in/assets/images/pune-to-mumbai-innova-crysta-cab.jpg",
  "description": "Book Pune to Mumbai Innova Crysta cab with Vedant Travels for premium comfort, spacious interiors, and a smooth ride. Perfect for families, business trips, or group travel with luggage.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7124"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3299",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/pune-to-mumbai-innova-crysta-cab"
  }
};



      
     
      


    return (
        <div>
           
           <Helmet>
  <title>Pune to Mumbai Innova Crysta Cab | Premium & Spacious </title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Innova Crysta cab with Vedant Travels for premium comfort, spacious interiors, and a smooth ride. Perfect for families, business trips, or group travel with luggage." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Innova Crysta Cab, Innova Crysta Pune to Mumbai, Premium SUV Cab Pune Mumbai, Vedant Travels Crysta Booking, Crysta Taxi Pune to Mumbai, Group Travel Cab Pune Mumbai, Spacious Cab Pune to Mumbai, Business Cab Pune to Mumbai, Pune to Mumbai Crysta Hire, Online Crysta Cab Booking Pune, Luxury SUV Taxi Pune Mumbai, Long Distance Crysta Travel, AC Innova Crysta Cab Pune, Pune to Mumbai Comfortable SUV, Best Crysta Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinnovacabs;